<script>
  import Comment from './Comment.svelte';
  import { t9n } from '../../lib/translate';
  import { TS } from '../../config/translation-keys';
  import Rating from './Rating.svelte'

  // component options  ------------------------------------------------------ //

  export let profile;
  export let percentages;
  export let feedbacks_count;

  let num_of_items = 25;
  let showing_all_comments = t9n(TS.FEEDBACK_SHOWING_ALL_COMMENTS)
  let plus_comments_to_load = 25;
  let feedbacks = profile.feedback.comments.slice(0, num_of_items);

  const load_more = async () => {
    num_of_items = num_of_items + plus_comments_to_load
    feedbacks = profile.feedback.comments.slice(0, num_of_items);
  }
</script>


<style>
  .center {
    text-align: center;
  }

  .font-heading {
    font-family: Roboto, sans-serif;
    font-size: .875rem;
    letter-spacing: -0.0178571429em;
    text-transform: inherit;
    font-weight: 800;
    color: #616161;
    padding: 1px;
    margin: 7px;
    display:inline-block;
  }

  .comments-tree {
    background: linear-gradient(#b5b5b5, #b5b5b5) no-repeat center/1px 100%;
    position: relative;
    width: 100%;
  }

  .comments-tree .tree-item {
    /*display: table-row;*/
    margin-bottom: 15px;
  }

  .tree-today {
    border-radius: 4px;
    background-color: var(--button_background_color);
    color: var(--button_text_color);
    font-weight: 400;
    text-align: center;
    padding: 6px 12px;
    margin-bottom: 0;
    display: inline-block;
  }

  .detail-section {
    margin-top: 8px;
    padding: 24px;
    background: #ffffff9c;
  }

  .no-comment-yet {
    background-color: rgba(79, 79, 79, 0);
    border-radius: 0px;
    text-align: center;
    padding: 6px 12px;
    display: inline-block;
    font-size: .875rem;
    letter-spacing: -0.0178571429em;
    text-transform: inherit;
    font-weight: 800;
    color: #616161;
  }

  /* Mobile Mode
  *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {

    .detail-section {
      padding: 4px;
    }

    .comments-tree {
      background: none;
      position: relative;
      width: 100%;
    }

    .tree-today {
      display: none;
    }

  }

</style>

<div class="mdc-card center roll-out" style="margin-top: 8px; background-color: rgba(255, 255, 255, 0.9);">
  <div class="font-heading">
    <p>
      {profile.role_title} ({feedbacks_count})
    </p>
  </div>
</div>

<Rating {percentages} {profile} />

<div class="mdc-card detail-section roll-out" style="overflow: auto">

    {#if !!profile.feedback.comments.length}
    <div class="comments-tree">
      <article class="tree-item center">
        <span class="tree-today">{profile.date_label}</span>
      </article>
      {#each feedbacks as comment}
        <Comment comment={comment} role={profile.is_orderer ? 'worker' : 'orderer'} />
      {/each}
    </div>
    {:else}
    <div style="position: relative; width: 100%;">
      <article class="center">
        <span class="no-comment-yet">{profile.feedback.no_comment_text}</span>
      </article>
    </div>
    {/if}


  {#if profile.feedback.comments.length > feedbacks.length}
    <div class="center">
      <button id="load-more-comments"
              class="mdc-button mdc-button--raised"
              style="align-self: end;"
              on:click|stopPropagation|preventDefault={() => load_more() }>
          {profile.feedback.load_more_label}
      </button>
    </div>
  {:else}
    <div style="position: relative; width: 100%;">
      <article class="center">
        <span class="no-comment-yet">{showing_all_comments}</span>
      </article>
    </div>
  {/if}
</div>
